@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(-738_427_141)
internal val Res.string.ui_company_dialog_title: StringResource by lazy {
      StringResource("string:ui_company_dialog_title", "ui_company_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13713, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13097, 51),
      ))
    }

@delegate:ResourceContentHash(59_977_868)
internal val Res.string.ui_company_listing_btn_add_company: StringResource by lazy {
      StringResource("string:ui_company_listing_btn_add_company", "ui_company_listing_btn_add_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13765, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13149, 58),
      ))
    }

@delegate:ResourceContentHash(959_713_004)
internal val Res.string.ui_company_listing_btn_load_more: StringResource by lazy {
      StringResource("string:ui_company_listing_btn_load_more", "ui_company_listing_btn_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13824, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13208, 52),
      ))
    }

@delegate:ResourceContentHash(1_155_161_766)
internal val Res.string.ui_company_listing_header_counters: StringResource by lazy {
      StringResource("string:ui_company_listing_header_counters", "ui_company_listing_header_counters", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13885, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13261, 70),
      ))
    }

@delegate:ResourceContentHash(-1_800_739_518)
internal val Res.string.ui_company_listing_header_name: StringResource by lazy {
      StringResource("string:ui_company_listing_header_name", "ui_company_listing_header_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13956, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13332, 54),
      ))
    }

@delegate:ResourceContentHash(-967_613_796)
internal val Res.string.ui_company_listing_no_companies_found: StringResource by lazy {
      StringResource("string:ui_company_listing_no_companies_found", "ui_company_listing_no_companies_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14011, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13387, 69),
      ))
    }

@delegate:ResourceContentHash(1_140_172_190)
internal val Res.string.ui_company_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_company_listing_search_placeholder", "ui_company_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14089, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13457, 73),
      ))
    }

@delegate:ResourceContentHash(-896_686_024)
internal val Res.string.ui_company_listing_showing: StringResource by lazy {
      StringResource("string:ui_company_listing_showing", "ui_company_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14163, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13531, 86),
      ))
    }

@delegate:ResourceContentHash(-1_963_325_949)
internal val Res.string.ui_company_splash_desc: StringResource by lazy {
      StringResource("string:ui_company_splash_desc", "ui_company_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14246, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13618, 126),
      ))
    }

@delegate:ResourceContentHash(-1_995_450_493)
internal val Res.string.ui_company_splash_title: StringResource by lazy {
      StringResource("string:ui_company_splash_title", "ui_company_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14381, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13745, 43),
      ))
    }

@delegate:ResourceContentHash(-1_594_403_747)
internal val Res.string.ui_devices_detail_device_actions_btn_close: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_close", "ui_devices_detail_device_actions_btn_close", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14421, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13789, 58),
      ))
    }

@delegate:ResourceContentHash(128_979_711)
internal val Res.string.ui_devices_detail_device_actions_btn_reboot: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_reboot", "ui_devices_detail_device_actions_btn_reboot", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14484, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13848, 59),
      ))
    }

@delegate:ResourceContentHash(-752_741_875)
internal val Res.string.ui_devices_detail_device_actions_btn_update_runtime: StringResource by
    lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_update_runtime", "ui_devices_detail_device_actions_btn_update_runtime", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14556, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13908, 79),
      ))
    }

@delegate:ResourceContentHash(1_454_388_143)
internal val Res.string.ui_devices_detail_device_actions_btn_update_www: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_update_www", "ui_devices_detail_device_actions_btn_update_www", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14640, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13988, 71),
      ))
    }

@delegate:ResourceContentHash(1_645_108_522)
internal val Res.string.ui_devices_detail_device_actions_dialog_title: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_dialog_title", "ui_devices_detail_device_actions_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14716, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14060, 73),
      ))
    }

@delegate:ResourceContentHash(1_165_142_392)
internal val Res.string.ui_devices_detail_device_actions_reboot_queued: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_reboot_queued", "ui_devices_detail_device_actions_reboot_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14790, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14134, 78),
      ))
    }

@delegate:ResourceContentHash(2_040_675_498)
internal val Res.string.ui_devices_detail_device_actions_update_queued: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_update_queued", "ui_devices_detail_device_actions_update_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14897, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14213, 94),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_devices_detail_devicedui_btn_cancel: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_cancel", "ui_devices_detail_devicedui_btn_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15012, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14308, 54),
      ))
    }

@delegate:ResourceContentHash(164_164_459)
internal val Res.string.ui_devices_detail_devicedui_btn_change_default_app: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_change_default_app", "ui_devices_detail_devicedui_btn_change_default_app", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15071, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14363, 82),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_devices_detail_devicedui_btn_delete: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_delete", "ui_devices_detail_devicedui_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15166, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14446, 54),
      ))
    }

@delegate:ResourceContentHash(988_176_674)
internal val Res.string.ui_devices_detail_devicedui_btn_device_actions: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_device_actions", "ui_devices_detail_devicedui_btn_device_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15225, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14501, 74),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_devices_detail_devicedui_btn_edit: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_edit", "ui_devices_detail_devicedui_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15300, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14576, 52),
      ))
    }

@delegate:ResourceContentHash(1_521_527_482)
internal val Res.string.ui_devices_detail_devicedui_btn_screenshot: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_screenshot", "ui_devices_detail_devicedui_btn_screenshot", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15353, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14629, 66),
      ))
    }

@delegate:ResourceContentHash(1_023_558_733)
internal val Res.string.ui_devices_detail_devicedui_campaigns_empty: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_campaigns_empty", "ui_devices_detail_devicedui_campaigns_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15424, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14696, 79),
      ))
    }

@delegate:ResourceContentHash(-1_723_276_995)
internal val Res.string.ui_devices_detail_devicedui_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_delete_confirm_message", "ui_devices_detail_devicedui_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15508, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14776, 158),
      ))
    }

@delegate:ResourceContentHash(-1_251_850_257)
internal val Res.string.ui_devices_detail_devicedui_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_delete_confirm_title", "ui_devices_detail_devicedui_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15683, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14935, 76),
      ))
    }

@delegate:ResourceContentHash(-215_227_754)
internal val Res.string.ui_devices_detail_devicedui_label_active_campaigns: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_active_campaigns", "ui_devices_detail_devicedui_label_active_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15760, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15012, 82),
      ))
    }

@delegate:ResourceContentHash(-1_572_294_076)
internal val Res.string.ui_devices_detail_devicedui_label_campaign_id_prefix: StringResource by
    lazy {
      StringResource("string:ui_devices_detail_devicedui_label_campaign_id_prefix", "ui_devices_detail_devicedui_label_campaign_id_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15843, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15095, 84),
      ))
    }

@delegate:ResourceContentHash(153_672_569)
internal val Res.string.ui_devices_detail_devicedui_label_default_app: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_default_app", "ui_devices_detail_devicedui_label_default_app", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15928, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15180, 81),
      ))
    }

@delegate:ResourceContentHash(-1_892_599_668)
internal val Res.string.ui_devices_detail_devicedui_label_duration_priority: StringResource by
    lazy {
      StringResource("string:ui_devices_detail_devicedui_label_duration_priority", "ui_devices_detail_devicedui_label_duration_priority", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16006, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15262, 99),
      ))
    }

@delegate:ResourceContentHash(81_821_120)
internal val Res.string.ui_devices_detail_devicedui_label_id: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_id", "ui_devices_detail_devicedui_label_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16106, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15362, 48),
      ))
    }

@delegate:ResourceContentHash(1_892_315_140)
internal val Res.string.ui_devices_detail_devicedui_label_online_status: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_online_status", "ui_devices_detail_devicedui_label_online_status", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16155, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15411, 75),
      ))
    }

@delegate:ResourceContentHash(-902_466_203)
internal val Res.string.ui_devices_detail_devicedui_label_opening_hours: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_opening_hours", "ui_devices_detail_devicedui_label_opening_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16235, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15487, 75),
      ))
    }

@delegate:ResourceContentHash(-576_114_565)
internal val Res.string.ui_devices_detail_devicedui_label_resolution: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_resolution", "ui_devices_detail_devicedui_label_resolution", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16311, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15563, 68),
      ))
    }

@delegate:ResourceContentHash(-1_707_257_235)
internal val Res.string.ui_devices_detail_devicedui_label_type: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_type", "ui_devices_detail_devicedui_label_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16380, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15632, 54),
      ))
    }

@delegate:ResourceContentHash(1_308_036_181)
internal val Res.string.ui_devices_detail_devicedui_label_versions: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_versions", "ui_devices_detail_devicedui_label_versions", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16435, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15687, 62),
      ))
    }

@delegate:ResourceContentHash(-1_600_695_492)
internal val Res.string.ui_devices_detail_devicedui_status_closed: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_status_closed", "ui_devices_detail_devicedui_status_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16498, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15750, 57),
      ))
    }

@delegate:ResourceContentHash(1_769_579_710)
internal val Res.string.ui_devices_detail_devicedui_status_offline: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_status_offline", "ui_devices_detail_devicedui_status_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16560, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15808, 62),
      ))
    }

@delegate:ResourceContentHash(-1_707_876_243)
internal val Res.string.ui_devices_detail_devicedui_status_online: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_status_online", "ui_devices_detail_devicedui_status_online", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16627, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15871, 57),
      ))
    }

@delegate:ResourceContentHash(1_609_547_695)
internal val Res.string.ui_devices_detail_monitoring_empty: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_empty", "ui_devices_detail_monitoring_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16689, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15929, 82),
      ))
    }

@delegate:ResourceContentHash(-252_798_588)
internal val Res.string.ui_devices_detail_monitoring_free: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_free", "ui_devices_detail_monitoring_free", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16772, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16012, 57),
      ))
    }

@delegate:ResourceContentHash(-1_474_408_480)
internal val Res.string.ui_devices_detail_monitoring_header_disk: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_disk", "ui_devices_detail_monitoring_header_disk", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16834, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16070, 56),
      ))
    }

@delegate:ResourceContentHash(2_142_257_332)
internal val Res.string.ui_devices_detail_monitoring_header_network: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_network", "ui_devices_detail_monitoring_header_network", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16977, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16213, 63),
      ))
    }

@delegate:ResourceContentHash(-1_480_788_192)
internal val Res.string.ui_devices_detail_monitoring_header_network_speed: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_network_speed", "ui_devices_detail_monitoring_header_network_speed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16891, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16127, 85),
      ))
    }

@delegate:ResourceContentHash(84_393_920)
internal val Res.string.ui_devices_detail_monitoring_header_ram: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_ram", "ui_devices_detail_monitoring_header_ram", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17037, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16277, 51),
      ))
    }

@delegate:ResourceContentHash(-590_140_832)
internal val Res.string.ui_devices_detail_monitoring_header_temp: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_temp", "ui_devices_detail_monitoring_header_temp", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17089, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16329, 56),
      ))
    }

@delegate:ResourceContentHash(-2_134_404_382)
internal val Res.string.ui_devices_detail_monitoring_header_timestamp: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_timestamp", "ui_devices_detail_monitoring_header_timestamp", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17146, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16386, 65),
      ))
    }

@delegate:ResourceContentHash(2_106_412_229)
internal val Res.string.ui_devices_detail_monitoring_offline: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_offline", "ui_devices_detail_monitoring_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17224, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16452, 56),
      ))
    }

@delegate:ResourceContentHash(2_138_183_680)
internal val Res.string.ui_devices_detail_monitoring_speed_format: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_speed_format", "ui_devices_detail_monitoring_speed_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17285, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16509, 73),
      ))
    }

@delegate:ResourceContentHash(820_523_378)
internal val Res.string.ui_devices_detail_monitoring_title: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_title", "ui_devices_detail_monitoring_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17359, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16583, 58),
      ))
    }

@delegate:ResourceContentHash(-281_637_087)
internal val Res.string.ui_devices_detail_monitoring_today: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_today", "ui_devices_detail_monitoring_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17410, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16642, 58),
      ))
    }

@delegate:ResourceContentHash(-712_948_530)
internal val Res.string.ui_devices_detail_monitoring_yesterday: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_yesterday", "ui_devices_detail_monitoring_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17469, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16701, 66),
      ))
    }

@delegate:ResourceContentHash(936_220_866)
internal val Res.string.ui_devices_edit_deviceeui_btn_save: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_btn_save", "ui_devices_edit_deviceeui_btn_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17532, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16768, 50),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_devices_edit_deviceeui_cancel: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_cancel", "ui_devices_edit_deviceeui_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17583, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16819, 48),
      ))
    }

@delegate:ResourceContentHash(-1_655_862_933)
internal val Res.string.ui_devices_edit_deviceeui_dialog_title_select_location: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_dialog_title_select_location", "ui_devices_edit_deviceeui_dialog_title_select_location", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17636, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16868, 82),
      ))
    }

@delegate:ResourceContentHash(-1_428_792_705)
internal val Res.string.ui_devices_edit_deviceeui_error: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_error", "ui_devices_edit_deviceeui_error", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17723, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16951, 47),
      ))
    }

@delegate:ResourceContentHash(407_123_856)
internal val Res.string.ui_devices_edit_deviceeui_label_address: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_address", "ui_devices_edit_deviceeui_label_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17775, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16999, 71),
      ))
    }

@delegate:ResourceContentHash(262_444_405)
internal val Res.string.ui_devices_edit_deviceeui_label_aspect_ratio: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_aspect_ratio", "ui_devices_edit_deviceeui_label_aspect_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17851, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17071, 68),
      ))
    }

@delegate:ResourceContentHash(-1_504_359_035)
internal val Res.string.ui_devices_edit_deviceeui_label_height: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_height", "ui_devices_edit_deviceeui_label_height", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17924, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17140, 54),
      ))
    }

@delegate:ResourceContentHash(-428_210_153)
internal val Res.string.ui_devices_edit_deviceeui_label_identification: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_identification", "ui_devices_edit_deviceeui_label_identification", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17979, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17195, 90),
      ))
    }

@delegate:ResourceContentHash(-1_385_667_318)
internal val Res.string.ui_devices_edit_deviceeui_label_location: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_location", "ui_devices_edit_deviceeui_label_location", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18070, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17286, 60),
      ))
    }

@delegate:ResourceContentHash(-902_466_203)
internal val Res.string.ui_devices_edit_deviceeui_label_openning_hours: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_openning_hours", "ui_devices_edit_deviceeui_label_openning_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18131, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17347, 74),
      ))
    }

@delegate:ResourceContentHash(-181_754_221)
internal val Res.string.ui_devices_edit_deviceeui_label_orientation: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_orientation", "ui_devices_edit_deviceeui_label_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18206, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17422, 67),
      ))
    }

@delegate:ResourceContentHash(1_185_549_412)
internal val Res.string.ui_devices_edit_deviceeui_label_registry_name: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_registry_name", "ui_devices_edit_deviceeui_label_registry_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18274, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17490, 81),
      ))
    }

@delegate:ResourceContentHash(-1_137_077_148)
internal val Res.string.ui_devices_edit_deviceeui_label_resolution_mode: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_resolution_mode", "ui_devices_edit_deviceeui_label_resolution_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18364, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17572, 75),
      ))
    }

@delegate:ResourceContentHash(-1_789_417_629)
internal val Res.string.ui_devices_edit_deviceeui_label_resolution_preset: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_resolution_preset", "ui_devices_edit_deviceeui_label_resolution_preset", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18444, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17648, 81),
      ))
    }

@delegate:ResourceContentHash(-1_749_834_787)
internal val Res.string.ui_devices_edit_deviceeui_label_technical_specs: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_technical_specs", "ui_devices_edit_deviceeui_label_technical_specs", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18530, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17730, 87),
      ))
    }

@delegate:ResourceContentHash(1_890_066_273)
internal val Res.string.ui_devices_edit_deviceeui_label_visual: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_visual", "ui_devices_edit_deviceeui_label_visual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18618, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17818, 66),
      ))
    }

@delegate:ResourceContentHash(-950_193_906)
internal val Res.string.ui_devices_edit_deviceeui_label_width: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_width", "ui_devices_edit_deviceeui_label_width", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18685, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17885, 53),
      ))
    }

@delegate:ResourceContentHash(637_200_222)
internal val Res.string.ui_devices_edit_deviceeui_mode_custom: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_mode_custom", "ui_devices_edit_deviceeui_mode_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18743, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17939, 53),
      ))
    }

@delegate:ResourceContentHash(852_351_005)
internal val Res.string.ui_devices_edit_deviceeui_mode_picker: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_mode_picker", "ui_devices_edit_deviceeui_mode_picker", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18805, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17993, 53),
      ))
    }

@delegate:ResourceContentHash(789_435_372)
internal val Res.string.ui_devices_edit_deviceeui_no_image: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_no_image", "ui_devices_edit_deviceeui_no_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18867, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18047, 54),
      ))
    }

@delegate:ResourceContentHash(1_039_136_930)
internal val Res.string.ui_devices_edit_deviceeui_no_locations_found: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_no_locations_found", "ui_devices_edit_deviceeui_no_locations_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18926, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18102, 76),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.ui_devices_edit_deviceeui_ok: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_ok", "ui_devices_edit_deviceeui_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19011, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18179, 40),
      ))
    }

@delegate:ResourceContentHash(-1_880_793_913)
internal val Res.string.ui_devices_edit_deviceeui_orientation_horizontal: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_horizontal", "ui_devices_edit_deviceeui_orientation_horizontal", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19162, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18322, 80),
      ))
    }

@delegate:ResourceContentHash(1_704_725_411)
internal val Res.string.ui_devices_edit_deviceeui_orientation_horizontal_reversed: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_horizontal_reversed", "ui_devices_edit_deviceeui_orientation_horizontal_reversed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19056, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18220, 101),
      ))
    }

@delegate:ResourceContentHash(395_207_407)
internal val Res.string.ui_devices_edit_deviceeui_orientation_vertical: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_vertical", "ui_devices_edit_deviceeui_orientation_vertical", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19343, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18503, 74),
      ))
    }

@delegate:ResourceContentHash(-1_609_945_429)
internal val Res.string.ui_devices_edit_deviceeui_orientation_vertical_reversed: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_vertical_reversed", "ui_devices_edit_deviceeui_orientation_vertical_reversed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19243, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18403, 99),
      ))
    }

@delegate:ResourceContentHash(2_101_478_870)
internal val Res.string.ui_devices_edit_deviceeui_search_location_placeholder: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_search_location_placeholder", "ui_devices_edit_deviceeui_search_location_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19422, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18578, 77),
      ))
    }

@delegate:ResourceContentHash(1_278_651_301)
internal val Res.string.ui_devices_edit_deviceeui_select_location_placeholder: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_select_location_placeholder", "ui_devices_edit_deviceeui_select_location_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19512, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18656, 85),
      ))
    }

@delegate:ResourceContentHash(959_713_004)
internal val Res.string.ui_devices_listing_btn_load_more: StringResource by lazy {
      StringResource("string:ui_devices_listing_btn_load_more", "ui_devices_listing_btn_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19602, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18742, 52),
      ))
    }

@delegate:ResourceContentHash(-1_238_925_862)
internal val Res.string.ui_devices_listing_header_campaigns: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_campaigns", "ui_devices_listing_header_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19663, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18795, 55),
      ))
    }

@delegate:ResourceContentHash(81_821_120)
internal val Res.string.ui_devices_listing_header_id: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_id", "ui_devices_listing_header_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19719, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18851, 40),
      ))
    }

@delegate:ResourceContentHash(1_897_430_367)
internal val Res.string.ui_devices_listing_header_name: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_name", "ui_devices_listing_header_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19760, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18892, 54),
      ))
    }

@delegate:ResourceContentHash(-1_315_232_960)
internal val Res.string.ui_devices_listing_header_status: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_status", "ui_devices_listing_header_status", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19819, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18947, 48),
      ))
    }

@delegate:ResourceContentHash(-1_707_257_235)
internal val Res.string.ui_devices_listing_header_type: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_type", "ui_devices_listing_header_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19868, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18996, 46),
      ))
    }

@delegate:ResourceContentHash(-1_267_153_063)
internal val Res.string.ui_devices_listing_placeholder_search: StringResource by lazy {
      StringResource("string:ui_devices_listing_placeholder_search", "ui_devices_listing_placeholder_search", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19915, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19043, 61),
      ))
    }

@delegate:ResourceContentHash(1_709_888_971)
internal val Res.string.ui_devices_listing_showing: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing", "ui_devices_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20147, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19259, 78),
      ))
    }

@delegate:ResourceContentHash(95_044_728)
internal val Res.string.ui_devices_listing_showing_middle: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing_middle", "ui_devices_listing_showing_middle", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19989, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19105, 45),
      ))
    }

@delegate:ResourceContentHash(462_025_241)
internal val Res.string.ui_devices_listing_showing_prefix: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing_prefix", "ui_devices_listing_showing_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20035, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19151, 53),
      ))
    }

@delegate:ResourceContentHash(-2_043_824_381)
internal val Res.string.ui_devices_listing_showing_suffix: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing_suffix", "ui_devices_listing_showing_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20093, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19205, 53),
      ))
    }

@delegate:ResourceContentHash(1_769_579_710)
internal val Res.string.ui_devices_listing_stat_offline: StringResource by lazy {
      StringResource("string:ui_devices_listing_stat_offline", "ui_devices_listing_stat_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20234, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19338, 51),
      ))
    }

@delegate:ResourceContentHash(-1_707_876_243)
internal val Res.string.ui_devices_listing_stat_online: StringResource by lazy {
      StringResource("string:ui_devices_listing_stat_online", "ui_devices_listing_stat_online", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20290, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19390, 46),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_devices_listing_stat_total: StringResource by lazy {
      StringResource("string:ui_devices_listing_stat_total", "ui_devices_listing_stat_total", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20341, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19437, 49),
      ))
    }

@delegate:ResourceContentHash(-1_085_949_842)
internal val Res.string.ui_devices_listing_title: StringResource by lazy {
      StringResource("string:ui_devices_listing_title", "ui_devices_listing_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20391, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19487, 60),
      ))
    }

@delegate:ResourceContentHash(116_606_363)
internal val Res.string.ui_devices_listing_type_indoor: StringResource by lazy {
      StringResource("string:ui_devices_listing_type_indoor", "ui_devices_listing_type_indoor", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20456, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19548, 46),
      ))
    }

@delegate:ResourceContentHash(967_519_333)
internal val Res.string.ui_devices_listing_type_outdoor: StringResource by lazy {
      StringResource("string:ui_devices_listing_type_outdoor", "ui_devices_listing_type_outdoor", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20507, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19595, 51),
      ))
    }

@delegate:ResourceContentHash(30_127_065)
internal val Res.string.ui_devices_splash_desc: StringResource by lazy {
      StringResource("string:ui_devices_splash_desc", "ui_devices_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20559, 286),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19647, 290),
      ))
    }

@delegate:ResourceContentHash(-1_097_985_949)
internal val Res.string.ui_devices_splash_title: StringResource by lazy {
      StringResource("string:ui_devices_splash_title", "ui_devices_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20846, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19938, 51),
      ))
    }

@delegate:ResourceContentHash(-1_259_742_481)
internal val Res.string.ui_error_unknown: StringResource by lazy {
      StringResource("string:ui_error_unknown", "ui_error_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20902, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19990, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_company_dialog_title", Res.string.ui_company_dialog_title)
  map.put("ui_company_listing_btn_add_company", Res.string.ui_company_listing_btn_add_company)
  map.put("ui_company_listing_btn_load_more", Res.string.ui_company_listing_btn_load_more)
  map.put("ui_company_listing_header_counters", Res.string.ui_company_listing_header_counters)
  map.put("ui_company_listing_header_name", Res.string.ui_company_listing_header_name)
  map.put("ui_company_listing_no_companies_found", Res.string.ui_company_listing_no_companies_found)
  map.put("ui_company_listing_search_placeholder", Res.string.ui_company_listing_search_placeholder)
  map.put("ui_company_listing_showing", Res.string.ui_company_listing_showing)
  map.put("ui_company_splash_desc", Res.string.ui_company_splash_desc)
  map.put("ui_company_splash_title", Res.string.ui_company_splash_title)
  map.put("ui_devices_detail_device_actions_btn_close", Res.string.ui_devices_detail_device_actions_btn_close)
  map.put("ui_devices_detail_device_actions_btn_reboot", Res.string.ui_devices_detail_device_actions_btn_reboot)
  map.put("ui_devices_detail_device_actions_btn_update_runtime", Res.string.ui_devices_detail_device_actions_btn_update_runtime)
  map.put("ui_devices_detail_device_actions_btn_update_www", Res.string.ui_devices_detail_device_actions_btn_update_www)
  map.put("ui_devices_detail_device_actions_dialog_title", Res.string.ui_devices_detail_device_actions_dialog_title)
  map.put("ui_devices_detail_device_actions_reboot_queued", Res.string.ui_devices_detail_device_actions_reboot_queued)
  map.put("ui_devices_detail_device_actions_update_queued", Res.string.ui_devices_detail_device_actions_update_queued)
  map.put("ui_devices_detail_devicedui_btn_cancel", Res.string.ui_devices_detail_devicedui_btn_cancel)
  map.put("ui_devices_detail_devicedui_btn_change_default_app", Res.string.ui_devices_detail_devicedui_btn_change_default_app)
  map.put("ui_devices_detail_devicedui_btn_delete", Res.string.ui_devices_detail_devicedui_btn_delete)
  map.put("ui_devices_detail_devicedui_btn_device_actions", Res.string.ui_devices_detail_devicedui_btn_device_actions)
  map.put("ui_devices_detail_devicedui_btn_edit", Res.string.ui_devices_detail_devicedui_btn_edit)
  map.put("ui_devices_detail_devicedui_btn_screenshot", Res.string.ui_devices_detail_devicedui_btn_screenshot)
  map.put("ui_devices_detail_devicedui_campaigns_empty", Res.string.ui_devices_detail_devicedui_campaigns_empty)
  map.put("ui_devices_detail_devicedui_delete_confirm_message", Res.string.ui_devices_detail_devicedui_delete_confirm_message)
  map.put("ui_devices_detail_devicedui_delete_confirm_title", Res.string.ui_devices_detail_devicedui_delete_confirm_title)
  map.put("ui_devices_detail_devicedui_label_active_campaigns", Res.string.ui_devices_detail_devicedui_label_active_campaigns)
  map.put("ui_devices_detail_devicedui_label_campaign_id_prefix", Res.string.ui_devices_detail_devicedui_label_campaign_id_prefix)
  map.put("ui_devices_detail_devicedui_label_default_app", Res.string.ui_devices_detail_devicedui_label_default_app)
  map.put("ui_devices_detail_devicedui_label_duration_priority", Res.string.ui_devices_detail_devicedui_label_duration_priority)
  map.put("ui_devices_detail_devicedui_label_id", Res.string.ui_devices_detail_devicedui_label_id)
  map.put("ui_devices_detail_devicedui_label_online_status", Res.string.ui_devices_detail_devicedui_label_online_status)
  map.put("ui_devices_detail_devicedui_label_opening_hours", Res.string.ui_devices_detail_devicedui_label_opening_hours)
  map.put("ui_devices_detail_devicedui_label_resolution", Res.string.ui_devices_detail_devicedui_label_resolution)
  map.put("ui_devices_detail_devicedui_label_type", Res.string.ui_devices_detail_devicedui_label_type)
  map.put("ui_devices_detail_devicedui_label_versions", Res.string.ui_devices_detail_devicedui_label_versions)
  map.put("ui_devices_detail_devicedui_status_closed", Res.string.ui_devices_detail_devicedui_status_closed)
  map.put("ui_devices_detail_devicedui_status_offline", Res.string.ui_devices_detail_devicedui_status_offline)
  map.put("ui_devices_detail_devicedui_status_online", Res.string.ui_devices_detail_devicedui_status_online)
  map.put("ui_devices_detail_monitoring_empty", Res.string.ui_devices_detail_monitoring_empty)
  map.put("ui_devices_detail_monitoring_free", Res.string.ui_devices_detail_monitoring_free)
  map.put("ui_devices_detail_monitoring_header_disk", Res.string.ui_devices_detail_monitoring_header_disk)
  map.put("ui_devices_detail_monitoring_header_network", Res.string.ui_devices_detail_monitoring_header_network)
  map.put("ui_devices_detail_monitoring_header_network_speed", Res.string.ui_devices_detail_monitoring_header_network_speed)
  map.put("ui_devices_detail_monitoring_header_ram", Res.string.ui_devices_detail_monitoring_header_ram)
  map.put("ui_devices_detail_monitoring_header_temp", Res.string.ui_devices_detail_monitoring_header_temp)
  map.put("ui_devices_detail_monitoring_header_timestamp", Res.string.ui_devices_detail_monitoring_header_timestamp)
  map.put("ui_devices_detail_monitoring_offline", Res.string.ui_devices_detail_monitoring_offline)
  map.put("ui_devices_detail_monitoring_speed_format", Res.string.ui_devices_detail_monitoring_speed_format)
  map.put("ui_devices_detail_monitoring_title", Res.string.ui_devices_detail_monitoring_title)
  map.put("ui_devices_detail_monitoring_today", Res.string.ui_devices_detail_monitoring_today)
  map.put("ui_devices_detail_monitoring_yesterday", Res.string.ui_devices_detail_monitoring_yesterday)
  map.put("ui_devices_edit_deviceeui_btn_save", Res.string.ui_devices_edit_deviceeui_btn_save)
  map.put("ui_devices_edit_deviceeui_cancel", Res.string.ui_devices_edit_deviceeui_cancel)
  map.put("ui_devices_edit_deviceeui_dialog_title_select_location", Res.string.ui_devices_edit_deviceeui_dialog_title_select_location)
  map.put("ui_devices_edit_deviceeui_error", Res.string.ui_devices_edit_deviceeui_error)
  map.put("ui_devices_edit_deviceeui_label_address", Res.string.ui_devices_edit_deviceeui_label_address)
  map.put("ui_devices_edit_deviceeui_label_aspect_ratio", Res.string.ui_devices_edit_deviceeui_label_aspect_ratio)
  map.put("ui_devices_edit_deviceeui_label_height", Res.string.ui_devices_edit_deviceeui_label_height)
  map.put("ui_devices_edit_deviceeui_label_identification", Res.string.ui_devices_edit_deviceeui_label_identification)
  map.put("ui_devices_edit_deviceeui_label_location", Res.string.ui_devices_edit_deviceeui_label_location)
  map.put("ui_devices_edit_deviceeui_label_openning_hours", Res.string.ui_devices_edit_deviceeui_label_openning_hours)
  map.put("ui_devices_edit_deviceeui_label_orientation", Res.string.ui_devices_edit_deviceeui_label_orientation)
  map.put("ui_devices_edit_deviceeui_label_registry_name", Res.string.ui_devices_edit_deviceeui_label_registry_name)
  map.put("ui_devices_edit_deviceeui_label_resolution_mode", Res.string.ui_devices_edit_deviceeui_label_resolution_mode)
  map.put("ui_devices_edit_deviceeui_label_resolution_preset", Res.string.ui_devices_edit_deviceeui_label_resolution_preset)
  map.put("ui_devices_edit_deviceeui_label_technical_specs", Res.string.ui_devices_edit_deviceeui_label_technical_specs)
  map.put("ui_devices_edit_deviceeui_label_visual", Res.string.ui_devices_edit_deviceeui_label_visual)
  map.put("ui_devices_edit_deviceeui_label_width", Res.string.ui_devices_edit_deviceeui_label_width)
  map.put("ui_devices_edit_deviceeui_mode_custom", Res.string.ui_devices_edit_deviceeui_mode_custom)
  map.put("ui_devices_edit_deviceeui_mode_picker", Res.string.ui_devices_edit_deviceeui_mode_picker)
  map.put("ui_devices_edit_deviceeui_no_image", Res.string.ui_devices_edit_deviceeui_no_image)
  map.put("ui_devices_edit_deviceeui_no_locations_found", Res.string.ui_devices_edit_deviceeui_no_locations_found)
  map.put("ui_devices_edit_deviceeui_ok", Res.string.ui_devices_edit_deviceeui_ok)
  map.put("ui_devices_edit_deviceeui_orientation_horizontal", Res.string.ui_devices_edit_deviceeui_orientation_horizontal)
  map.put("ui_devices_edit_deviceeui_orientation_horizontal_reversed", Res.string.ui_devices_edit_deviceeui_orientation_horizontal_reversed)
  map.put("ui_devices_edit_deviceeui_orientation_vertical", Res.string.ui_devices_edit_deviceeui_orientation_vertical)
  map.put("ui_devices_edit_deviceeui_orientation_vertical_reversed", Res.string.ui_devices_edit_deviceeui_orientation_vertical_reversed)
  map.put("ui_devices_edit_deviceeui_search_location_placeholder", Res.string.ui_devices_edit_deviceeui_search_location_placeholder)
  map.put("ui_devices_edit_deviceeui_select_location_placeholder", Res.string.ui_devices_edit_deviceeui_select_location_placeholder)
  map.put("ui_devices_listing_btn_load_more", Res.string.ui_devices_listing_btn_load_more)
  map.put("ui_devices_listing_header_campaigns", Res.string.ui_devices_listing_header_campaigns)
  map.put("ui_devices_listing_header_id", Res.string.ui_devices_listing_header_id)
  map.put("ui_devices_listing_header_name", Res.string.ui_devices_listing_header_name)
  map.put("ui_devices_listing_header_status", Res.string.ui_devices_listing_header_status)
  map.put("ui_devices_listing_header_type", Res.string.ui_devices_listing_header_type)
  map.put("ui_devices_listing_placeholder_search", Res.string.ui_devices_listing_placeholder_search)
  map.put("ui_devices_listing_showing", Res.string.ui_devices_listing_showing)
  map.put("ui_devices_listing_showing_middle", Res.string.ui_devices_listing_showing_middle)
  map.put("ui_devices_listing_showing_prefix", Res.string.ui_devices_listing_showing_prefix)
  map.put("ui_devices_listing_showing_suffix", Res.string.ui_devices_listing_showing_suffix)
  map.put("ui_devices_listing_stat_offline", Res.string.ui_devices_listing_stat_offline)
  map.put("ui_devices_listing_stat_online", Res.string.ui_devices_listing_stat_online)
  map.put("ui_devices_listing_stat_total", Res.string.ui_devices_listing_stat_total)
  map.put("ui_devices_listing_title", Res.string.ui_devices_listing_title)
  map.put("ui_devices_listing_type_indoor", Res.string.ui_devices_listing_type_indoor)
  map.put("ui_devices_listing_type_outdoor", Res.string.ui_devices_listing_type_outdoor)
  map.put("ui_devices_splash_desc", Res.string.ui_devices_splash_desc)
  map.put("ui_devices_splash_title", Res.string.ui_devices_splash_title)
  map.put("ui_error_unknown", Res.string.ui_error_unknown)
}
